import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import CheckinsActions, { CheckinsRedux, CheckinsTypes } from '../Redux/CheckinsRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

const checkinsCrudObservable = createCRUDObservable({
  mainRedux: CheckinsRedux,
  reduxPath: 'checkins',
})

const checkinsExcelEpic = (action$, store, { Api }) =>
  action$.ofType(CheckinsTypes.CheckinsExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.checkins.getCheckinsExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            CheckinsActions.CheckinsExcelSuccess(),
          ]
        })
    ))

export const checkinsObservers = Object.assign({}, checkinsCrudObservable.observers, {})

export const checkinsEpic = combineEpics(
  checkinsCrudObservable.epic,
  checkinsExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CheckinsObservable.js